import {DeviceProtocol, DeviceProtocolBeginSeal, DeviceProtocolOperation} from "@hybird/core/device/protocol";
import service from "@hybird/core/request";
import url from "@hybird/device/request";
import {DeviceInfo} from "@hybird/device/config";

/**
 * @abstract
 */
export class DefaultDeviceProtocol extends DeviceProtocol {

  constructor(deviceProvide, deviceInfo, deviceProtocolOption) {
    super(deviceProvide, deviceInfo, deviceProtocolOption);
  }

  async _deviceStatus() {
    if (this.request) {
      return (await this.request?.deviceStatusSend(this.deviceInfo.number)) ?? false;
    } else {
      const deviceStatus = await service.getFrom(url.onlineStatus, {
        number: this.deviceInfo.number
      });

      this.online = !!deviceStatus.data;

      return this.online;
    }
  }

  set deviceInfo(deviceInfo) {
    if (!(deviceInfo instanceof DeviceInfo)) {
      deviceInfo = Object.assign(new DeviceInfo(), deviceInfo);
    }

    super.deviceInfo = deviceInfo;
  }

  get deviceInfo() {
    return super.deviceInfo;
  }
}

/**
 * @abstract
 */
export class DefaultDeviceProtocolBeginSeal extends DeviceProtocolBeginSeal {

  async _remoteUnlock(documentRemoteId, type) {
    //只有mqtt协议才发送
    if (this.deviceProtocol.deviceConnectProvide.connectType === 2 && type === 3) {
      await service.putForm(url.remoteUnlock, {
        number: this.deviceInfo.number, documentRemoteId: documentRemoteId
      })
    }
  }

  async getBusinessKeySend() {
    return await service.getFrom(url.getBusinessKey, {
      deviceNumber: this.deviceInfo.number,
      documentId: this.deviceInfo.documentId
    }).then(data => {
      return data.data.businessKey
    });
  }
}

/**
 * @abstract
 */
export class DefaultDeviceProtocolOperation extends DeviceProtocolOperation {

  async _operationLog(logType,data) {
    let dic = {
      number: this.deviceInfo.number, logType
    }
    if(data){
      dic = {...dic,...data}
    }
    return service.post(url.operationLog, dic);
  }
}

export class DeviceProtocolRequest {
  /**
   * @type{DefaultDeviceProtocol}
   */
  deviceProtocol;

  /**
   * @type{DeviceInfo}
   */
  deviceInfo;

  constructor(deviceProtocol) {
    this.deviceProtocol = deviceProtocol;
    this.deviceInfo = this.deviceProtocol.deviceInfo
  }

  /**
   * 获取设备mqtt状态
   * @param number 设备序列号
   * @return {Promise<boolean>} 是否在线
   */
  async deviceStatusSend(number) {
    return false;
  }

  /**
   * 用户登录
   * @param params{{
   *       model,
   *       sessionId,
   *       deviceType,
   *       number,
   *       gps,
   * }}
   * @return {Promise<{
   *   userName,staffId,timestamp,sign
   * }>}
   * sign: 秘钥
   */
  async userLoginSend(params) {
  }

  /**
   * 获取蓝牙授权登录参数,
   * @param number 设备序列号
   * @deprecated 已经在{@link DeviceProtocolRequest.userLoginSend}方法中返回
   * @return {Promise<{
   *   userName,staffId,timestamp,sign
   * }>}
   * sign: 秘钥
   */
  async getSignSend(number) {
  }

  /**
   *
   * @param params{{
   *       number,
   *       energyType,
   *       energy,
   *       bleMac,
   *       plank,
   *       systemVersion,
   *       version
   * }}
   * @return {Promise<void>}
   */
  async propertySyncSend(params) {
  }

  /**
   *
   * @param params{{}}
   * @return {Promise<void>}
   */
  async documentPrivilegeUploadSend(params) {
  }

  /**
   * 用户退出
   * @return {Promise<void>}
   */
  async userLogoutSend() {
  }

  /**
   * 获取指纹导入信息
   * @param number 设备序列号
   * @return {Promise<*>}
   */
  async fingerprintImportSend(number) {
  }

  /**
   * 指纹导入结果
   * @param params{{
   *   type,position,auth,featureString,number
   * }}
   * type 指纹类型
   * position 指纹标示位
   * auth 是否特权
   * featureString 指纹特征值
   * @return {Promise<axios.AxiosResponse<any>>}
   */
  async fingerprintImportStateSend(params) {
  }

  /**
   * 远程设备移动通知
   * @param params{{
   *   documentRemoteId, status
   * }}
   * documentRemoteId 远程id
   * @return {Promise<axios.AxiosResponse<any>>}
   */
  async equipmentMoveSend(params) {
  }

  /**
   * @param data {{
   *       businessType,
   *       documentId,
   *       sealId,
   *       staffId,
   *       lon,
   *       lat,
   *       warningTime
   * }}
   * @return {Promise<any>}
   */
  async stampDataWarningSend(data) {
  }

  /**
   * 盖印数据上报
   * @param data{{
   *   documentId,
   *   position,
   *   sealId,
   *   leftTimes,
   *   gps,
   *   sealTime,
   *   number,
   *   staffId,
   *   coverId
   * }} 盖印数据
   * @return {Promise<axios.AxiosResponse<any>>}
   */
  async stampDataUploadSend(data) {
  }

  /**
   * 远程审批状态
   * @param params{{
   *   documentRemoteId
   * }}
   * documentRemoteId 远程id
   * @return {Promise<*>}
   */
  async remoteResultSend(params) {
  }

  /**
   * 固件更新状态上报
   * @param data{{
   *   number,
   *   step,
   *   version,
   * }} 升级后版本号
   * @return {Promise<axios.AxiosResponse<any>>}
   */
  async firmwareUpdateSend(data) {
  }

  /**
   * 完成更换印章
   * @param params{{
   *   sealId,
   *   motion,
   *   status,
   * }}
   * sealId 印章id
   * motion 蘸墨类型 1:蘸墨印章 2:非蘸墨印章
   * status 是否成功状态 1:成功  目前只有成功
   * @return {Promise<axios.AxiosResponse<any>>}
   */
  async changeSealFinishSend(params) {
  }

  /**
   * 解除锁定
   * @param data{{
   *   number,
   *   documentRemoteId
   * }}
   * @return {Promise<void>}
   */
  async remoteUnlockSend(data) {
  }

  /**
   * 指纹录入, 获取录入数据状态
   * @param params{{
   *   number,
   *   staffId,
   *   remote,
   *   valid
   * }}
   * staffId 用户id
   * valid 是否验证
   * @return {Promise<{auth: Number, position: Number, type: Number}>} type 指纹类型 1:新增 4:指纹验证  position 指纹标示位 auth 是否特权
   */
  async fingerprintEnteringSend(params) {
  }

  /**
   * 删除指纹
   * @param params{{
   * number,
   *   staffId
   * }}
   * staffId 用户id
   * @return {Promise<number[]>}删除的指纹列表
   */
  async fingerprintRemoveSend(params) {
  }

  /**
   * 删除指纹状态回调
   * @param params{{
   *   staffId,
   *   type,
   *   position
   * }}
   * staffId 用户id
   * type 类型
   * position 指纹标示位
   * @return {Promise<axios.AxiosResponse<any>>}
   */
  async fingerprintRemoveFinishSend(params) {
  }

  /**
   * 导入指纹
   * @param params{{
   *   staffId,
   *   type,
   *   position
   * }}
   * staffId 用户id
   * type 类型
   * @return {Promise<axios.AxiosResponse<any>>}
   */
  async fingerprintClearFinishSend(params) {
  }

  /**
   * 指纹录入完成上传特征值
   * @param params{{
   *   file,
   *   number,
   *   position,
   *   status,
   *   staffId,
   * }}
   * type 指纹类型
   * position 指纹标示位
   * auth 是否特权
   * file{File} 文件
   * staffId 员工id
   * @return {Promise<axios.AxiosResponse<any>>}
   */
  async fingerprintFinishSend(params) {
  }
}